const de = {
  notificationsSubheader: 'Benachrichtigungseinstellungen',
  summarySettings: 'E-Mail-Zusammenfassungen über neue Beiträge',
  summaryInfo: {
    title: 'E-Mail-Zusammenfassungen',
    content:
      'Hier können Sie einstellen, ob und wie oft Sie E-Mail-Zusammenfassungen über neue Beiträge erhalten wollen. Sie erhalten dabei nur Benachrichtigungen aus den oben aktivierten Bereichen.'
  },
  summaryInfoBlockedDepartments: {
    title: 'Wichtig',
    content:
      'Beiträge aus den unten grau hinterlegten Hochschulbereichen erhalten Sie immer und können nicht abgewählt werden.'
  },
  autosaveInfo: {
    title: 'Automatische Speicherung',
    content: 'Einstellungen, die hier vorgenommen werden, werden automatisch gespeichert.'
  },
  notificationSettingsHeaders: {
    bell: 'Glocke',
    email: 'E-Mail'
  },
  receive: 'Erhalten',
  days: {
    oneDay: '1 Tag',
    sevenDays: '7 Tage',
    fourteenDays: '14 Tage'
  }
};

export default de;
export type ProfileTranslation = typeof de;
